export default __webpack_public_path__ + "static/media/shoe07.417d6c28.jpg";